import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {CommonComponent} from '../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {AccountService} from '../../services/account.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../environments/environment';
import {ConfigurationService} from '../../services/configuration.service';
import {DialogService} from 'primeng/dynamicdialog';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent extends CommonComponent implements OnInit {
  programName = environment.productName;
  namespace = environment.namespace;

  exchangeRate: number;
  lastUpdateDate: Date;
  targetAmount: number;
  originAmountValue: number;
  charge: number;
  withCharges: number;
  oneDollar: number;
  webPage = null;
  guatemalan = environment.es === 'GTM';
  bahuProcessingHost = environment.bahuProcessingHost;
  homeCarousel = environment.home_carousel;
  facebook = environment.socialNetworks.facebook;
  instagram = environment.socialNetworks.instagram;
  tiktok = environment.socialNetworks.tiktok;
  twitter = environment.socialNetworks.twitter;
  youtube = environment.socialNetworks.youtube;
  linkedin = environment.socialNetworks.linkedin;
  contactUsTextColor = environment.contactUsTextColor;

  constructor(
    @Inject(LOCALE_ID) readonly locale: string,
    private accountsService: AccountService,
    protected modalService: NgbModal,
    public router: Router,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    public configurationService: ConfigurationService,
    protected dialogService: DialogService,
    public deviceService: DeviceDetectorService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.configurationService.clearConfigurations();
    this.locale = this.locale.substring(0, 2);
  }

  ngOnInit() {
    this.exchangeRate = 0;
    this.targetAmount = 0;
    this.originAmountValue = 0;
    this.withCharges = 0;
    this.oneDollar = 0;
    this.charge = 6;
    this.configurationService.getPlatformConfig();
  }

  getExchangeRate() {
    this.loadingModalOn();
    // TODO
    // this.originAmount = +this.form.get('originAmount').value;
    this.withCharges = +this.originAmountValue + this.charge;
    const rate = {
      originAmount: this.originAmountValue
    };
    this.accountsService.getExchangeRate(this.originAmountValue).subscribe(
      (response: any) => {
        this.oneDollar = 1;
        this.targetAmount = response.targetCurrencyAmount;
        this.exchangeRate = response.exchangeRate;
        this.lastUpdateDate = response.lastUpdateDate;
        this.loadingModalOff();
      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }

  openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  onboardingPath() {
    this.router.navigate(['/onboarding']);
    scroll(0, 0);
  }

  openDepositForm() {
    const rutaPDF = `assets/documents/DDAform.pdf`;
    window.open(rutaPDF, '_blank');
  }
}
